module.exports = __webpack_public_path__ + "static/clubBNI-d8c51ab0a250c2dc7efdf28ab5fad9bd.jpg";